import { type IColumn, Table, Tooltip } from 'shared/ui'
import { getLabelAsNumberInternationalFormat, numberFormat } from 'shared/lib'
import { type IDuplicateReason, type ISkippedReason } from 'entities/Contacts/api/types'

import styles from './styles.module.scss'

interface IHistoryModalContentProps {
  data: IDuplicateReason[] | ISkippedReason[]
}

type IReason = (IDuplicateReason | ISkippedReason) & {
  id: number
}

export const HistoryModalContent = ({ data }: IHistoryModalContentProps) => {
  const columns: IColumn<IReason>[] = [
    {
      field: 'row',
      name: '#',
      minWidth: 84,
      renderRowCell: (row) => (
        <span className={styles.rowCell}>{numberFormat({ value: row.row })}</span>
      ),
    },
    {
      field: 'number',
      name: 'Phone',
      minWidth: 144,
      renderRowCell: (row) => getLabelAsNumberInternationalFormat(row.number.toString()),
    },
    {
      field: 'reason',
      name: 'Reason',
      minWidth: 234,
      maxWidth: 234,
      renderRowCell: (row) => (
        <Tooltip label={row.reason} withoutPointer>
          <span>{row.reason}</span>
        </Tooltip>
      ),
    },
  ]

  const rows = data.map((row, id) => ({ ...row, id }))

  return (
    <Table
      ariaLabel={'HistoryModalContent'}
      height='400px'
      rows={rows}
      columns={columns}
      noPagination
    />
  )
}
